import { RouteObject } from "react-router-dom";
import { withHandle } from "../../utils/route.util";
import { OrdersView } from "./OrdersView";
import { OrderView } from "./OrderView";
import { OrderDetailsTab } from "./tabs/OrderDetailsTab";
import { OrderItemsTab } from "./tabs/OrderItemsTab";
import { OrderEventLogsTab } from "./tabs/OrderEventLogsTab";
import { OrderShipmentsTab } from "./tabs/OrderShipmentsTab";

const orderDetailTabs: RouteObject[] = [
  {
    index: true,
    element: <OrderDetailsTab />,
    ...withHandle("order-details"),
  },
  {
    path: "details",
    element: <OrderDetailsTab />,
    ...withHandle("order-details"),
  },
  {
    path: "items",
    element: <OrderItemsTab />,
    ...withHandle("order-items"),
  },
  {
    path: "event-logs",
    element: <OrderEventLogsTab />,
    ...withHandle("order-event-logs"),
  },
  {
    path: "shipments",
    element: <OrderShipmentsTab />,
    ...withHandle("order-shipments"),
  },
  {
    path: "*",
    element: <OrderDetailsTab />,
    ...withHandle("order-details"),
  },
];

export const ordersRoutes: RouteObject[] = [
  {
    path: "orders",
    element: <OrdersView />,
    ...withHandle("orders"),
  },
  {
    path: "orders/:customerPublicId/:customerOrderId",
    element: <OrderView />,
    ...withHandle("order-detail", { navigateOnSandboxToggle: "/dashboard/orders" }),
    children: orderDetailTabs,
  },
];
